export const TOGGLE_EXIT_MODAL = 'TOGGLE_EXIT_MODAL';

export function toggleExitModal() {
  return {
    type: TOGGLE_EXIT_MODAL,
  };
}
